const PAGE_SIZE_DEFAULT = 100;
const PAGE_SIZE_INVENTORIES = 75;
const PAGE_SIZE_CASH_REGISTER = 25;
export const pageSizeTypes = {
  PAGE_SIZE_DEFAULT,
  PAGE_SIZE_INVENTORIES,
  PAGE_SIZE_CASH_REGISTER,
};
